export type Point = { x: number; y: number };
export type Tool = 'pen' | 'arrow' | 'rectangle' | 'text';
export type Mark = { tool: Tool; points: Point[]; color: string; width: number; text: string };
export interface AnnotationSource { url: string; name: string }

export function paintMark(ctx: CanvasRenderingContext2D, mark: Mark) {
  const start = mark.points[0], end = mark.points.at(-1);
  if (!start || !end) return;
  ctx.save(); ctx.strokeStyle = mark.color; ctx.fillStyle = mark.color; ctx.lineWidth = mark.width; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  if (mark.tool === 'text') {
    const size = Math.max(18, mark.width * 6);
    ctx.font = `700 ${size}px Arial, sans-serif`; ctx.textBaseline = 'top';
    ctx.shadowColor = '#0009'; ctx.shadowBlur = 3;
    mark.text.split('\n').forEach((line, index) => ctx.fillText(line, start.x, start.y + index * size * 1.25));
  } else if (mark.tool === 'rectangle') ctx.strokeRect(start.x, start.y, end.x - start.x, end.y - start.y);
  else {
    ctx.beginPath(); ctx.moveTo(start.x, start.y);
    if (mark.tool === 'pen') {
      mark.points.forEach(point => ctx.lineTo(point.x, point.y));
      if (mark.points.length === 1) ctx.lineTo(start.x + .1, start.y + .1);
    } else {
      ctx.lineTo(end.x, end.y);
      const angle = Math.atan2(end.y - start.y, end.x - start.x), head = Math.max(16, mark.width * 4);
      ctx.moveTo(end.x - head * Math.cos(angle - Math.PI / 6), end.y - head * Math.sin(angle - Math.PI / 6));
      ctx.lineTo(end.x, end.y); ctx.lineTo(end.x - head * Math.cos(angle + Math.PI / 6), end.y - head * Math.sin(angle + Math.PI / 6));
    }
    ctx.stroke();
  }
  ctx.restore();
}

